import { createContext, use } from "react";

/**
 * Attribute of the „(optional)“ mark inside the label of a `Field`; the error summary leaves the
 * mark out of the label it repeats.
 */
export const optionalMarkAttribute = "data-optional-mark";

/** No errors, outside a validated form or before its first failed submit. */
const noErrors: ReadonlyMap<string, string> = new Map();

/**
 * Errors of the controls of a validated form, by the `id` of the control (F-60, UX-008). `Field`
 * and `Checkbox` read the error of their control from here.
 */
export const FormErrorsContext = createContext<ReadonlyMap<string, string>>(noErrors);

/**
 * Returns the error the surrounding validated form found at a control.
 *
 * @param id - Identifier of the control.
 * @returns The message, or `null` without an error.
 */
export function useFormError(id: string): string | null {
  const errors = use(FormErrorsContext);
  const error = errors.get(id) ?? null;

  return error;
}
